import React from 'react';
import DynamicEditForm from '../../components/DynamicEditForm/DynamicEditForm.js'; // Import your form component
import { getStoredData } from "../../JsonFiles/fetchData.js";

const EditServicesPage = () => {
  const fields = getStoredData()?.["1"]?.AdminServices ?? {};
  const apiUrl = 'https://technow-overseasbackend.vercel.app/services'; // API URL for fetching/editing product
  const successRedirect = '/AdminServices'; // Where to redirect after a successful update

  return (
    <div>
      <DynamicEditForm
        fields={fields}
        apiUrl={apiUrl}
        successRedirect={successRedirect}
      />
    </div>
  );
};
export default EditServicesPage